import { myMessages } from "store/types";

export const updateCount = (count) => async (dispatch) => {
  dispatch({
    type: myMessages.SET_MESSAGE_COUNT,
    payload: count,
  });
};
